import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestUpdateExpense } from "./updateExpense.request";

const useExpenseUpdate = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchInternalBank = useRefetchQuery(["internal-bank"]);
  const refetchInternalBankHistory = useRefetchQuery(["internal-bank-history"]);
  const refetchStatistics = useRefetchQuery(["expenses-statistics"]);

  return useMutation({
    mutationFn: requestUpdateExpense,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchInternalBank();
      refetchInternalBankHistory();
      refetchStatistics();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useExpenseUpdate;
